'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMap(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M7.526 11.969V2.327L4.8.677A1.171 1.171 0 004.361.5v9.777l2.768 1.53c.12.063.262.134.397.162zM.8 11.842c.191 0 .375-.064.609-.199L3.49 10.49V.65c-.106.05-.205.106-.311.163L.588 2.27C.177 2.496 0 2.822 0 3.26v7.788c0 .495.297.793.8.793zm7.596.07a.815.815 0 00.177-.085l2.84-1.592c.41-.234.587-.553.587-.992V1.45c0-.496-.297-.793-.8-.793-.191 0-.375.063-.602.205l-2.202 1.26v9.791z", id: "Map__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Map__svg__a" })))));
}

module.exports = SvgMap;
//# sourceMappingURL=Map.js.map
